export const dateTimeConverter = (dateTime) => {
    if (dateTime) {
        let dateSplit = dateTime.split("T");
        let dateString = dateSplit[0];
        let timeString = dateSplit[1]?.split(".")[0];
        let finalDateTime = dateString + "\n" + timeString;
        return finalDateTime;
    } else {
        return "--";
    }
};

export const matchDateTimeConvert = (dateString) => {

    if (!dateString) return "--";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "--";

    // Extracting date components
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12;

    // Constructing the formatted date string
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}${ampm}`;

    return formattedDate;

}

export const newsDateFormat = (isoDate) => {
    if (isoDate) {
        const date = new Date(isoDate);

        // Convert to UTC
        const utcDate = new Date(date.toUTCString());

        // Get day name
        const dayName = utcDate.toLocaleString('en-US', { weekday: 'long', timeZone: 'UTC' });

        // Get day number
        const dayNumber = utcDate.getUTCDate();

        // Get month name
        const monthName = utcDate.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });

        // Get year
        const year = utcDate.getUTCFullYear();

        // Get hours and minutes
        let hours = utcDate.getUTCHours();
        let minutes = utcDate.getUTCMinutes();

        // Determine AM/PM
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;

        const formattedTime = `${hours}:${minutes} ${ampm}`;

        // Format the full date string
        return `${dayName} ${dayNumber} ${monthName}, ${year}  ${formattedTime}`;
    }
    else {
        return "--";
    }
};

export const dateIntoYYYY_MM_DD = (dateStr) => {
    if (dateStr) {
        const date = new Date(dateStr);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    } else {
        return null;
    }
};

export const formatDateToShortMonthDayYear = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
};

export const chatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    const localDate = new Date(dateTime.getTime() - (5.5 * 60 * 60 * 1000));
    const today = new Date();

    if (
        localDate.getFullYear() === today.getFullYear() &&
        localDate.getMonth() === today.getMonth() &&
        localDate.getDate() === today.getDate()
    ) {
        // if date is today, only show time in AM/PM format
        return localDate.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    } else {
        // if date is not today, show full date and time in AM/PM format
        return localDate.toLocaleString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        }).replace(',', ''); // remove the comma after the date
    }
}

export const chatUserLastMessageDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const now = new Date();

    const localDate = new Date(date.getTime() - (5.5 * 60 * 60 * 1000));
    const isWithinLastWeek = now.getTime() - date.getTime() < 7 * 24 * 60 * 60 * 1000;

    if (localDate.toLocaleDateString() === now.toLocaleDateString()) {
        return localDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    } else if (isWithinLastWeek) {
        return localDate.toLocaleDateString('en-US', { weekday: 'long' });
    } else if (localDate.toDateString() === new Date(now.getTime() - 24 * 60 * 60 * 1000).toDateString()) {
        return 'Yesterday';
    } else {
        return localDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
}

export const getDaysLeft = (targetDateStr) => {
    const today = new Date();
    const targetDate = new Date(targetDateStr);

    // Reset hours to ignore time differences
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
};